module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"wh100\">\n\n    <style>\n        .width-regulator td:nth-child(2) {\n            width : 17%;\n        }\n\n        .width-regulator td:nth-child(3) {\n            width : 21%;\n        }\n        .width-regulator thead td,\n        .width-regulator td:nth-child(1){\n            word-wrap:break-word;\n        }\n    </style>\n\n    <table class=\"w100 gl-report__table width-regulator\">\n        <thead>\n        <tr>\n            <td>Район</td>\n            <td>Количество хозяйств</td>\n            <td>Количество пользователей</td>\n        </tr>\n        </thead>\n    </table>\n\n    <div class=\"wh100\">\n        <div class=\"cell__abs_container\">\n            <div class=\"cell__abs overflow-y__auto\">\n                <table class=\"w100 gl-striped__table gl-report__table width-regulator\">\n                    <tbody>\n\n                    ")
    ;  data.rows.forEach(function (row) { 
    ; __append("\n\n                    <tr>\n                        <td>")
    ; __append(escapeFn( row.dist_name ))
    ; __append("</td>\n                        <td>")
    ; __append(escapeFn( row.farm_count ))
    ; __append("</td>\n                        <td>")
    ; __append(escapeFn( row.user_count ))
    ; __append("</td>\n                    </tr>\n\n                    ")
    ;  }) 
    ; __append("\n\n                    <tr>\n                        <th>Итого</th>\n                        <th>")
    ; __append(escapeFn( data.total.farm_count ))
    ; __append("</th>\n                        <th>")
    ; __append(escapeFn( data.total.user_count ))
    ; __append("</th>\n                    </tr>\n\n                    </tbody>\n                </table>\n            </div>\n        </div>\n    </div>\n\n</div>\n")
  }
  return __output.join("");

}